import moment from "moment";
import DatePreset from "../types/DatePreset";
var createDateLabel = function (startDate, endDate) {
    var momentStart = moment(startDate);
    var momentEnd = moment(endDate);
    var startLabel = momentStart.format("Do MMM YYYY");
    var endLabel = momentEnd.format("Do MMM YYYY");
    if (momentStart.isSame(momentEnd, "d")) {
        return startLabel;
    }
    return startLabel + " - " + endLabel;
};
var getStartAndEndDatesForPreset = function (preset) {
    var endDate = moment()
        .endOf("day")
        .toDate();
    var startDate = moment()
        .endOf("day")
        .toDate();
    switch (preset) {
        case DatePreset.LAST_TWELVE_MONTHS:
            startDate = moment()
                .subtract(1, "years")
                .add(1, "days")
                .startOf("day")
                .toDate();
            break;
        case DatePreset.LAST_THREE_MONTHS:
            startDate = moment()
                .subtract(3, "months")
                .add(1, "days")
                .startOf("day")
                .toDate();
            break;
        case DatePreset.LAST_THIRTY_DAYS:
            startDate = moment()
                .subtract(29, "days")
                .startOf("day")
                .toDate();
            break;
        case DatePreset.LAST_SEVEN_DAYS:
            startDate = moment()
                .subtract(6, "days")
                .startOf("day")
                .toDate();
            break;
        case DatePreset.ALL_TIME:
            startDate = moment(0).toDate();
            break;
        case DatePreset.END_OF_WEEK:
            endDate = moment()
                .endOf("week")
                .toDate();
            break;
        case DatePreset.END_OF_MONTH:
            endDate = moment()
                .endOf("month")
                .toDate();
            break;
        case DatePreset.END_OF_QUARTER:
            endDate = moment()
                .quarter(moment().quarter())
                .endOf("quarter")
                .toDate();
            break;
    }
    return [startDate, endDate];
};
export { createDateLabel, getStartAndEndDatesForPreset };
